module.exports = __webpack_public_path__ + "img/artass.bdd8ac01.png";